export default {
  draggedObject: {},
  selectedCriteria: null,
  segmentationGroups: {},
  segmentation: {},
  segmentationSize: null,
  segmentationRFVClusters: null,
  segmentationClientsCoordinates: {},
  segmentationStatusCount: {},
  segmentationLoaderCounter: 0,
  segmentationIsValid: false,
  autoUpdateSegmentInsights: false,
  isSegmentInsightsStale: false,
  persistOriginalSize: false,
  loadingSegmentInsights: false,
  currentSegmentToEvaluate: null,
  segmentationTabIndex: 0,
  segmentationModels: [],
  updatingSegmentsIds: [],
  refreshedSegments: [],
  segmentationAnalyticConfigurationsIds: [],
  tagsList: [],
  deletedTag: {},
  updatedTag: {},
}
